

























































import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import moment from "moment";
import {
  HsabTransactionDetail,
  WexClaimReceiptStatus,
  wexClaimReceiptStatusMap,
} from "@/shared/types";
import { wexClaimReceiptStatusIcon } from "@/shared/awesomeIconMapper";
import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import HsabTransactionChildRow from "@/shared/components/cash/hsabank/HsabTransactionChildRow.vue";

@Component({
  components: {
    HsabTransactionChildRow,
    Pill,
    CurrencyAmount,
  }
})
export default class HsabTransactionListItem extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  wexClaimReceiptStatusIcon = wexClaimReceiptStatusIcon;
  wexClaimReceiptStatusMap = wexClaimReceiptStatusMap;
  @Prop()
  transaction: HsabTransactionDetail;

  @Prop()
  isNotional: boolean;

  isOpen = false;

  toggleOpen (): void {
    this.isOpen = !this.isOpen;
  }

  get getPillType (): string {
    if (this.transaction.creditDebitIndicator === "C") {
      return "green-bg";
    }
    return "red-bg";
  }

  get showStatusPill () {
    return !this.transaction.isPosted;
  }

  get formattedDate (): string {
    const date = this.transaction.isPosted ? this.transaction.postingDate : this.transaction.effectiveDate;
    return moment(date).format("MMM D, YYYY");
  }

  get isCredit () {
    return this.transaction.creditDebitIndicator === "C";
  }

  get isDebit () {
    return this.transaction.creditDebitIndicator === "D";
  }

  get currencyClasses () {
    let result = "text-center pr-0 w-100 font-size-corection";
    if (this.transaction.creditDebitIndicator === "NA") {
      result = "text-center pr-0 w-100 font-size-corection color-grey";
    } else if (this.isDebit) {
      result = "text-center pr-0 w-100 font-size-corection color-red";
    }
    return [result];
  }
  showPill (status: WexClaimReceiptStatus) {
    return this.isNotional && status !== WexClaimReceiptStatus.None;
  }
  pillType (status: WexClaimReceiptStatus) {
    switch (status) {
      case WexClaimReceiptStatus.Complete:
        return "green-bg";
      case WexClaimReceiptStatus.ReceiptNeeded:
      case WexClaimReceiptStatus.NewReceiptNeeded:
      case WexClaimReceiptStatus.ReceiptOverdue:
        return "red-bg";
    }
    return "grey-bg";
  }
}
